var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "opd-card", attrs: { id: "printArea" } }, [
      _vm.IsNusingHome
        ? _c("div", { staticClass: "title-details" }, [
            _c("div", { staticClass: "logo" }, [
              _vm.hospital.logo
                ? _c("img", { attrs: { src: _vm.hospital.logo } })
                : _vm._e(),
            ]),
            _c("div", { staticClass: "Nursing-home-hospital-details" }, [
              _c("h2", [
                _vm._v(
                  "\n          " + _vm._s(_vm.hospital.name) + "\n        "
                ),
              ]),
              _c("p", [
                _vm._v("Hawai Nagar, Road no. A3, Birsa Chowk, Ranchi "),
              ]),
              _vm._m(0),
              _c("p", { staticStyle: { "text-align": "left" } }, [
                _c("span", [
                  _c("strong", [_vm._v("Mail:")]),
                  _vm._v(_vm._s(_vm.hospital.hospitalemail)),
                ]),
              ]),
            ]),
            _vm.tenantSetup && _vm.tenantSetup.displaySerialNumber
              ? _c("div", { staticClass: "opd-no" }, [
                  _c("p", [_vm._v("OPD NO.")]),
                  _c("span", [_vm._v(_vm._s(_vm.serialNumber))]),
                ])
              : _vm._e(),
          ])
        : _c(
            "div",
            {
              class:
                _vm.tenantSetup && _vm.tenantSetup.displaySerialNumber
                  ? "newheader"
                  : "header",
            },
            [
              _c("div", { staticClass: "logo" }, [
                _c("img", { attrs: { src: _vm.hospital.logo } }),
              ]),
              _c(
                "div",
                {
                  class:
                    _vm.tenantSetup && _vm.tenantSetup.displaySerialNumber
                      ? "newtitle-details"
                      : "title-details",
                },
                [
                  _c("h2", [_vm._v(_vm._s(_vm.hospital.name))]),
                  _c("p", [_vm._v(_vm._s(_vm.hospital.address))]),
                  _c("p", [_vm._v(_vm._s(_vm.hospital.contact))]),
                ]
              ),
              _vm.tenantSetup && _vm.tenantSetup.displaySerialNumber
                ? _c("div", { staticClass: "odp-number" }, [
                    _c("p", { staticClass: "opd-text" }, [_vm._v("OPD NO.")]),
                    _c("p", { staticClass: "opd-num" }, [
                      _vm._v(_vm._s(_vm.serialNumber)),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
      _c("div", { staticClass: "opd-title" }, [
        _vm._v("\n      OPD CARD\n    "),
      ]),
      _c("div", { staticClass: "details" }, [
        _c("div", { staticClass: "left" }, [
          _c("table", { staticStyle: { width: "100%" } }, [
            _c("tr", { staticClass: "row" }, [
              _c("td", { staticClass: "label" }, [_vm._v("UHID")]),
              _c("td", { staticStyle: { width: "5px" } }, [_vm._v(":")]),
              _c("td", [_vm._v(_vm._s(_vm.patient.uhid))]),
            ]),
            _c("tr", { staticClass: "row" }, [
              _c("td", { staticClass: "label" }, [_vm._v("Name")]),
              _c("td", { staticStyle: { width: "5px" } }, [_vm._v(":")]),
              _c("td", [_vm._v(_vm._s(_vm.patient.name))]),
            ]),
            _c("tr", { staticClass: "row" }, [
              _c("td", { staticClass: "label" }, [_vm._v("Age/Sex")]),
              _c("td", { staticStyle: { width: "5px" } }, [_vm._v(":")]),
              _c("td", [_vm._v(_vm._s(_vm.patient.ageSex))]),
            ]),
            _c("tr", { staticClass: "row" }, [
              _c("td", { staticClass: "label" }, [_vm._v("Relation Name")]),
              _c("td", { staticStyle: { width: "5px" } }, [_vm._v(":")]),
              _c("td", [_vm._v(_vm._s(_vm.patient.relation))]),
            ]),
            _c("tr", { staticClass: "row" }, [
              _c("td", { staticClass: "label" }, [_vm._v("Department")]),
              _c("td", { staticStyle: { width: "5px" } }, [_vm._v(":")]),
              _c("td", [
                _vm._v(_vm._s(_vm.patient.department || "Not Specified")),
              ]),
            ]),
            _c("tr", { staticClass: "row" }, [
              _c("td", { staticClass: "label" }, [_vm._v("Doctor Name")]),
              _c("td", { staticStyle: { width: "5px" } }, [_vm._v(":")]),
              _c("td", [_vm._v(_vm._s(_vm.patient.doctorname))]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "right" }, [
          _c("table", { staticStyle: { width: "100%" } }, [
            _c("tr", { staticClass: "row" }, [
              _c("td", { staticClass: "label" }, [_vm._v("Date")]),
              _c("td", { staticStyle: { width: "5px" } }, [_vm._v(":")]),
              _c("td", [_vm._v(_vm._s(_vm.patient.date))]),
            ]),
            _c("tr", { staticClass: "row" }, [
              _c("td", { staticClass: "label" }, [_vm._v("Contact No.")]),
              _c("td", { staticStyle: { width: "5px" } }, [_vm._v(":")]),
              _c("td", [_vm._v(_vm._s(_vm.patient.mobile))]),
            ]),
            _c("tr", { staticClass: "row" }, [
              _c("td", { staticClass: "label" }, [_vm._v("Address")]),
              _c(
                "td",
                { staticStyle: { width: "5px", "vertical-align": "top" } },
                [_vm._v(":")]
              ),
              _c("td", [_vm._v(_vm._s(_vm.patient.address))]),
            ]),
            _c("tr", { staticClass: "row" }, [
              _c("td", { staticClass: "label" }, [_vm._v("Fees")]),
              _c("td", { staticStyle: { width: "5px" } }, [_vm._v(":")]),
              _c("td", [
                _vm._v(_vm._s(_vm.currency) + _vm._s(_vm.patient.fees)),
              ]),
            ]),
            _c("tr", { staticClass: "row" }, [
              _c("td", { staticClass: "label" }, [_vm._v("Mode")]),
              _c("td", { staticStyle: { width: "5px" } }, [_vm._v(":")]),
              _c("td", [
                _vm._v(_vm._s(_vm.capitalizeFirst(_vm.patient.panel))),
              ]),
            ]),
            _c("tr", { staticClass: "row" }, [
              _c("td", { staticClass: "label" }, [_vm._v("Generated By")]),
              _c("td", { staticStyle: { width: "5px" } }, [_vm._v(":")]),
              _c("td", [_vm._v(_vm._s(_vm.patient.generatedbyname))]),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "timing" }, [
        _vm.tenantSetup &&
        _vm.tenantSetup.displayCustomOpdTimingText &&
        _vm.tenantSetup.customOpdTimingText
          ? _c("span", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.tenantSetup.customOpdTimingText) +
                  "\n  "
              ),
            ])
          : _c("span", [
              _vm._v(
                "\n      OPD TIMING: " + _vm._s(_vm.hospital.timing) + "\n  "
              ),
            ]),
      ]),
      _vm.showVitals
        ? _c("div", { staticClass: "extra-info" }, [
            _vm._m(1),
            _vm.patient.vitalupdateddate
              ? _c("div", { staticClass: "line-field" }, [
                  _c("strong", [_vm._v("Vitals recorded date ")]),
                  _vm._v(
                    ": " + _vm._s(_vm.patient.vitalupdateddate) + "\n        "
                  ),
                  _c("div", { staticClass: "dotted" }),
                ])
              : _vm._e(),
            _vm.tenantSetup && _vm.tenantSetup.displayVitalsInSingleLine
              ? _c("div", [
                  _c("div", { staticClass: "line-field" }, [
                    _c("strong", [_vm._v("Vitals:")]),
                    _vm.patient.height
                      ? _c("span", [
                          _vm._v(
                            "Height: " + _vm._s(_vm.patient.height) + ", "
                          ),
                        ])
                      : _vm._e(),
                    _vm.patient.weight
                      ? _c("span", [
                          _vm._v(
                            "Weight: " + _vm._s(_vm.patient.weight) + ", "
                          ),
                        ])
                      : _vm._e(),
                    _vm.patient.bp
                      ? _c("span", [
                          _vm._v("BP: " + _vm._s(_vm.patient.bp) + ", "),
                        ])
                      : _vm._e(),
                    _vm.patient.pulse
                      ? _c("span", [
                          _vm._v("Pulse: " + _vm._s(_vm.patient.pulse) + ", "),
                        ])
                      : _vm._e(),
                    _vm.patient.temperature
                      ? _c("span", [
                          _vm._v(
                            "Temp: " + _vm._s(_vm.patient.temperature) + ", "
                          ),
                        ])
                      : _vm._e(),
                    _vm.patient.bmi
                      ? _c("span", [
                          _vm._v("BMI: " + _vm._s(_vm.patient.bmi) + ", "),
                        ])
                      : _vm._e(),
                    _vm.patient.o2
                      ? _c("span", [
                          _vm._v("O2: " + _vm._s(_vm.patient.o2) + ", "),
                        ])
                      : _vm._e(),
                    _vm.patient.respiratoryRate
                      ? _c("span", [
                          _vm._v(
                            "RR: " + _vm._s(_vm.patient.respiratoryRate) + ", "
                          ),
                        ])
                      : _vm._e(),
                    _vm.patient.allergysumarry
                      ? _c("span", [
                          _vm._v(
                            "Allergies: " + _vm._s(_vm.patient.allergysumarry)
                          ),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "dotted" }),
                  ]),
                ])
              : _c("div", [
                  _vm.patient.height
                    ? _c("div", { staticClass: "line-field" }, [
                        _c("strong", [_vm._v("Height ")]),
                        _vm._v(
                          ": " + _vm._s(_vm.patient.height) + "\n              "
                        ),
                        _c("div", { staticClass: "dotted" }),
                      ])
                    : _vm._e(),
                  _vm.patient.weight
                    ? _c("div", { staticClass: "line-field" }, [
                        _c("strong", [_vm._v("Weight ")]),
                        _vm._v(
                          ": " + _vm._s(_vm.patient.weight) + "\n              "
                        ),
                        _c("div", { staticClass: "dotted" }),
                      ])
                    : _vm._e(),
                  _vm.patient.bp
                    ? _c("div", { staticClass: "line-field" }, [
                        _c("strong", [_vm._v("BP ")]),
                        _vm._v(
                          ": " + _vm._s(_vm.patient.bp) + "\n              "
                        ),
                        _c("div", { staticClass: "dotted" }),
                      ])
                    : _vm._e(),
                  _vm.patient.pulse
                    ? _c("div", { staticClass: "line-field" }, [
                        _c("strong", [_vm._v("Pulse ")]),
                        _vm._v(
                          ": " + _vm._s(_vm.patient.pulse) + "\n              "
                        ),
                        _c("div", { staticClass: "dotted" }),
                      ])
                    : _vm._e(),
                  _vm.patient.temperature
                    ? _c("div", { staticClass: "line-field" }, [
                        _c("strong", [_vm._v("Temperature ")]),
                        _vm._v(
                          ": " +
                            _vm._s(_vm.patient.temperature) +
                            "\n              "
                        ),
                        _c("div", { staticClass: "dotted" }),
                      ])
                    : _vm._e(),
                  _vm.patient.bmi
                    ? _c("div", { staticClass: "line-field" }, [
                        _c("strong", [_vm._v("BMI ")]),
                        _vm._v(
                          ": " + _vm._s(_vm.patient.bmi) + "\n              "
                        ),
                        _c("div", { staticClass: "dotted" }),
                      ])
                    : _vm._e(),
                  _vm.patient.o2
                    ? _c("div", { staticClass: "line-field" }, [
                        _c("strong", [_vm._v("O2 Saturation ")]),
                        _vm._v(
                          ": " + _vm._s(_vm.patient.o2) + "\n              "
                        ),
                        _c("div", { staticClass: "dotted" }),
                      ])
                    : _vm._e(),
                  _vm.patient.respiratoryRate
                    ? _c("div", { staticClass: "line-field" }, [
                        _c("strong", [_vm._v("Respiratory Rate ")]),
                        _vm._v(
                          ": " +
                            _vm._s(_vm.patient.respiratoryRate) +
                            "\n              "
                        ),
                        _c("div", { staticClass: "dotted" }),
                      ])
                    : _vm._e(),
                  _vm.patient.allergysumarry
                    ? _c("div", { staticClass: "line-field" }, [
                        _c("strong", [_vm._v("Known Drug Allergies ")]),
                        _vm._v(
                          ": " +
                            _vm._s(_vm.patient.allergysumarry) +
                            "\n              "
                        ),
                        _c("div", { staticClass: "dotted" }),
                      ])
                    : _vm._e(),
                ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { "margin-right": "20px" } }, [
        _c("strong", [_vm._v("Contact:")]),
        _vm._v(" 97714 40818, 99397 35164\n          "),
      ]),
      _c("span", [_c("strong", [_vm._v("GST:")]), _vm._v(" 20ATMPS8605A1ZX")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "line-field" }, [
      _c("strong", [_vm._v("Vitals")]),
      _c("div", { staticClass: "dotted" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }